




























































































































import AssessmentItem from '@/domain/assessment/entity/assessment-item.entity';
import { Vue, Component, Prop } from 'vue-property-decorator';
import FormPlanModalComponent from '@/views/activity/common/form-plan-modal.component.vue';
import ActionPlan from '@/domain/activity/entity/action-plan.entity';
import Priority from '@/domain/activity/entity/priority.entity';
import PdiService from '@/domain/pdi/pdi.service';
import { VbSnackbarService } from 'bag-of-holding-library';
import SkillTypes from '@/views/drd-2.0/skill/skill-types.json';
import ReadDrdCaption from '@/views/drd-2.0/components/read/read-drd-caption.component.vue';

@Component({
  components: {
    FormPlanModalComponent,
    ReadDrdCaption,
  },
})
class AssessmentItemComponent extends Vue {
  @Prop({
    type: Object,
    required: true,
  }) item!: AssessmentItem;

  @Prop({
    type: Object,
    required: true,
  }) skillType!: any;

  @Prop({
    type: Boolean,
    default: false,
  }) isEditMode!: boolean;

  @Prop({
    type: String,
    default: '',
  }) assessmentId!: string;

  @Prop({
    type: Array,
    default: () => [],
  }) priorityItems!: Priority[];

  @Prop({
    type: String,
    required: true,
  }) employeeUsername!: string;

  @Prop({
    type: String,
    required: true,
  }) language!: string;

  openPDIModal: boolean = false;

  formPlan: ActionPlan = new ActionPlan();

  loadingCreatePlan: boolean = false;

  loadingUpdatePlan: boolean = false;

  loadingViewPDI: boolean = false;

  skillTypes = SkillTypes;

  get calculateProgress() {
    if (this.item.type.isBoolean
    && this.item.response >= this.item.expected) {
      return 100;
    }
    if (this.item.expected && this.item.response) {
      return (this.item.response.value - this.skillType.decrementValue)
        / (this.item.expected.value - this.skillType.decrementValue) * 100;
    }
    return 0;
  }

  get getSkillOptionsBySkillType() {
    if (this.skillType.isBoolean) {
      return [
        {
          id: 7,
          name: 'Não',
          details: 'Não possui o conhecimento',
          value: 0,
          isSelected: true,
        },
        {
          id: 6,
          name: 'Sim',
          details: 'Possui o conhecimento',
          value: 1,
          isSelected: true,
        },
        {
          id: 5,
          name: 'Não se aplica',
          details: 'Quando não se aplica para o item por ser de outra unidade.',
          value: -1,
          isSelected: true,
        },
      ]
    }
    return this.skillType.options
  }

  handleUpdateResponse(newResponse: any) {
    let text = newResponse.name;

    if (this.skillType.isBoolean) {
      text = newResponse ? 'Aderente' : 'Não aderente';
    }

    this.item.response = {
      value: newResponse.value,
      text,
      details: newResponse.details,
    }
  }

  handleCreatePDI() {
    this.formPlan = new ActionPlan(
      {
        what: this.item.whatPTBR,
        planType: this.item.type.value,
        skillId: this.item.skillId,
      },
    );
    this.openPDIModal = true;
  }

  async handleViewPDI() {
    await this.getPdiById();
    this.openPDIModal = true;
  }

  async getPdiById() {
    try {
      this.loadingViewPDI = true;
      this.formPlan = await PdiService.getPlanById(this.item.planId);
    } catch (error) {
      VbSnackbarService.handleHttpError(error)
    } finally {
      this.loadingViewPDI = false;
    }
  }

  createPlan(plan: ActionPlan) {
    this.loadingCreatePlan = true;
    PdiService.create(plan, this.employeeUsername)
      .then(({ data }) => {
        VbSnackbarService.showSuccess('Plano criado com sucesso!')
        this.openPDIModal = false;
        this.item.planId = data.planId;
        this.item.planState = data.state;
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error)
      }).finally(() => {
        this.loadingCreatePlan = false;
      });
  }

  updatePlan(plan: ActionPlan) {
    this.loadingUpdatePlan = true;
    PdiService.update(plan, this.employeeUsername)
      .then(() => {
        VbSnackbarService.showSuccess('Plano atualizado com sucesso!');
        this.openPDIModal = false;
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error)
      }).finally(() => {
        this.loadingUpdatePlan = false;
      });
  }

  handleUpdatePlanField(event: any) {
    this.formPlan[event.field] = event.value;
  }

  get getProgressLabel() {
    if (this.item.response.value === -1) {
      return 'Não se aplica';
    }
    if (this.skillType.isBoolean) {
      return this.item.response
        && this.item.response.value >= this.item.expected.value
        ? 'Atende o esperado' : 'Abaixo do esperado';
    }
    if (this.item.response.value < 0) {
      return `${this.item.response.text}/${this.item.expected.value - this.skillType.decrementValue}`;
    }
    return `${this.item.response ? this.item.response.value - this.skillType.decrementValue : 'Não respondido'}
            /${this.item.expected.value - this.skillType.decrementValue}`;
  }

  get showPdiButton() {
    return this.item.type.value !== 'RESPONSIBILITY';
  }

  get showLegendButton() {
    return this.item.type.value !== 'KNOWLEDGE';
  }

  get disabledResponse() {
    return !this.isEditMode && this.assessmentId !== '' && this.assessmentId !== null;
  }
}

export default AssessmentItemComponent;
